import TemplateView from '../TemplateView'
import ResizableInput from './ResizableInput'
import ScrollableContainer from '../util/ScrollableContainer'
import {LinkifiedText} from '../components/LinkifiedText'
import {EntityTextLimits} from 'constants'

export class Description extends TemplateView {
    constructor({
        maxLength = EntityTextLimits.MAX_CPT_DESCRIPTION,
        onKeyDown = () => {},
        onChange = () => {},
    } = {}) {
        super()

        this.params = {
            maxLength,
        }

        this.callbacks = {
            onKeyDown,
            onChange,
        }

        this.state = {
            editable: false,
            loading: false,
            text: '',
            placeholder: '',
        }

        this.onStatePropertyChanged('loading', loading => this.resizableInput.setLoading(loading))
        this.onStatePropertyChanged('placeholder', placeholder => this.resizableInput.setState({placeholder}))
        this.onStatePropertyChanged('editable', (editable) => {
            this.resizableInput.setState({editable: editable})
        })

        this.onStatePropertyChanged('text', text => {
            this.resizableInput.toggle(!text)
            this.textPlaceholder.toggle(!!text)
            this.resizableInput.setState({text})
            this.textPlaceholder.setState({text})
        })

    }

    templateHtml() {
        return '<div class="components_description"/>'
    }

    afterRender() {
        this.resizableInput = new ResizableInput({
            maxLength: this.params.maxLength,
            onKeyDown: () => this.callbacks.onKeyDown(),
            onBlur: (text) => this._handleInputChange(text),
        }).init(this.$el)

        this.textPlaceholder = new ScrollableContainer(
            null,
            new LinkifiedText(),
            {
                containerClass: 'descriptionScrollableWrapper',
                contentWrapperClass: 'descriptionText',
            }
        ).init(this.$el)

        this.textPlaceholder.getEl().click(() => this._showInput())

        this.renderInitialState()
    }

    getText() {
        return this.state.text
    }

    /**
     * Needed for old panel controllers
     */
    setLoading(loading) {
        this.setState({loading})
    }

    _showInput() {
        this.textPlaceholder.toggle(false)
        this.resizableInput.toggle(true)
        this.resizableInput.focus()
    }

    _handleInputChange(text) {
        this.textPlaceholder.toggle(!!text)
        this.resizableInput.toggle(!text)
        this.textPlaceholder.setState({text})

        if (this.state.text !== text)
            this.callbacks.onChange(text)
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/Description.js